import React from 'react';

const Divider = ({ className = '' }) => {
  return (
    <hr
      className={`my-3 ${className}`}
      style={{
        borderColor: 'var(--border-input)',
        borderTopWidth: '1px',
        opacity: 1 
      }}
    />
  );
};

export default Divider;
